module.exports = __webpack_public_path__ + "media/effects-4.ad6f891e.webm";